import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import app from './app';

const rootReducer = combineReducers({
  app: persistReducer({
    key: 'app',
    storage,
  }, app),
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.ts